import { accountEntityName } from '../../backend/features/accounts/shared';
import { useConfig } from '@juvare/common-web-ui/config';
import { useDynamicColumnDefinitions } from '@juvare/platform-sdk-react/ui/components/EntityTable/dynamicColumns';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { useSelector } from 'react-redux';
export const useContactManagementConfig = () => {
    const { dynamicColumnsEnabled } = useSelector(getSettings);
    const dynamicColumnFetcher = useDynamicColumnDefinitions(accountEntityName, dynamicColumnsEnabled);
    return useConfig([Object.assign(Object.assign({}, dynamicColumnFetcher), { reload: () => dynamicColumnFetcher.mutate(), key: 'dynamicColumns' })], 'contactManagement');
};
